<template src="./index.html"></template>

<script>
export default {
    name: "imageUpload",
    props: ['maxSize', 'fileSum', 'model', 'page_index'],
    data(){
        return {
            file: null,
            fileInfoList: [],
            eventName: "POSTFILEUPLOAD",
            error: [],                      // 에러 메세지
            getMessage: null,                // 안내 메세지
            previewStyle:  "fileUpload"
        }
    },
    created(){
        let model = this.model
        if(model){
            if(model.length > 0) {
                this.fileInfoList = []
                model.map(value =>{
                    this.fileInfoList.push(value)
                })
            }
        }

    },
    watch: {
        model(){
            let model = this.model
            this.fileInfoList = []
            if(model){
                if(model.length > 0) {
                    model.map(value =>{
                        this.fileInfoList.push(value)
                    })
                }
            }
            return this.model
        }
    },
    computed: {
        limitSize(){
            let result = "";
            if(this.maxSize === undefined){
                result = 200;
            }else{
                result = this.maxSize;
            }
            let maxAudioSize = result*1000*1000
            return maxAudioSize;
        },
        limitFileSum(){
            let result = "";
            if(this.fileSum === undefined){
                result = 3;
            }else{
                result = this.fileSum;
            }
            return result;
        },
        guideMessage: {
            get: function () {
                return this.getMessage
            },
            // setter
            set: function (title) {
                // 안내 메세지
                const limitFormat = "파일 포멧은 pdf, jpg, png 만 허용됩니다."                                  // 파일 포멧
                const limitSize = "최대 용량은 200MB까지만 지원합니다."                                             // 파일 용량
                const limitAmount = "최대 업로드 가능한 파일 갯수는 " + this.limitFileSum + " 개입니다."  // 등록 가능한 파일 수 제한
                const limtDragCount = "파일은 1개씩 업로드 가능합니다."            // 파일 multiple 제한( 단일 등록만 가능 )
                const messageCollection = {
                    limitFormat: limitFormat,
                    limitSize: limitSize,
                    limitAmount: limitAmount,
                    limtDragCount: limtDragCount
                }

                const keys = Object.keys(messageCollection)
                keys.forEach(key =>{
                    if(key == title){
                        this.getMessage = messageCollection[key]
                    }
                })
            } 
        },
        codec(){
            let codec = this.fileInfoList.map((item, index) =>{
                const formatName = item.metadata.codec.toLowerCase()
                if(item.hasOwnProperty("metadata")){
                    switch(formatName){
                        case "mpeg 1 layer 3":
                            return "MP3"
                            break;
                        case "pcm":
                            return "WAV"
                            break;
                        default:
                            return formatName
                            break;
                    }
                }
            })
            return codec
        },
    },
    methods: {
        dragUnOver(){
            let el = document.getElementById("filelabel"+ this.page_index);
            el.style.opacity = 0.8;
            el.style.visibility = "visible"; 
        },
        dragOver(){
            let el = document.getElementById("filelabel"+ this.page_index);
            el.style.visibility = "hidden";
        },
        formatCheck(fileName){
            // 파일 포멧 검색 odf, jpg, png
            let reg = new RegExp('pdf|jpg|png','i');
            if(!reg.test(fileName)) {
                this.popupOpen('tracks_guideMessage', 'limitFormat')
                this.dragUnOver();
                this.error.push("formatCheck")
            }
        },
        sizeCheck(fileSize){
            // 파일 용량 검색 200MB 이하
            if(fileSize > this.limitSize) {
                this.popupOpen('tracks_guideMessage','limitSize')
                this.dragUnOver();
                this.error.push("sizeCheck")
            }
        },
        listFileSumCheck(){
            // 업로드된 리스트 확인후 최대 업로드 파일 개수 제한 Default : 3
            let dataLength = this.fileInfoList.length;
            if(dataLength > this.limitFileSum){
                this.popupOpen('dacLay07', 'limitAmount')
                this.dragUnOver();
                this.error.push("listFileSumCheck")
            }
        },
        listFormatCheck(uploadFileName){
            // 업로드된 리스트 확인후 파일 포멧 제한 pdf, jpg, png
            let listLength = this.fileInfoList.length;
            let files = this.fileInfoList;
            let uploadFileFormat = uploadFileName.substring((uploadFileName.length - 3), uploadFileName.length);
          
            if(files.length > this.limitFileSum){
                this.popupOpen('tracks_guideMessage', 'formatDuplication')
                this.dragUnOver();
                this.error.push("listFormatCheck")
            }

            for (let i in files){
                let fileName = files[i].display_name;
                let fileFormat = fileName.substring((fileName.length - 3), fileName.length);
                if(uploadFileFormat === fileFormat){
                    this.popupOpen('tracks_guideMessage', 'formatDuplication')
                    this.error.push("listFormatCheck")
                }
            }
        },
        filesUploadCountCheck(files){
            // 여러개 파일이 Drag 여부
            if(files.length > 1){
                this.popupOpen('tracks_guideMessage','limtDragCount')
                this.error.push("filesUploadCountCheck")
            }
        },
        delete_file(event,index){
            let listData = this.fileInfoList;
            let listItem = event.target.closest("tr")
            listItem.classList.add("testCSS");

            // 파일 삭제 API
            const id = listData[index].id
            this.deleteFileAPi(id)
            setTimeout(function(){
                listData.splice(index, 1);
                listItem.classList.remove("testCSS");
            }, 800)
        },
        fileDrop_ex(event){
            // 사용 보류
            this.error = []  // 에러 초기화
            const files = event.dataTransfer.files
            this.file = files[0] // 파일 저장
            const fileName = files[0].name
            const fileSize = files[0].size

            //File Check List
            this.formatCheck(fileName)
            this.sizeCheck(fileSize)
            this.filesUploadCountCheck(files)
           
            // 로딩바 생성
            const dropbox = document.getElementsByClassName("dropbox")[0] // dropbox Select
            const loader = document.createElement("div")
            this.loading(dropbox, loader)
    
            if(this.error.length > 0){
                this.loading_close(dropbox, loader)
                this.dragUnOver()
                return false
            }else{
                if (files[0]) {
                    reader.readAsDataURL(files[0])
                    this.uploadfileAPi(this.file, this.eventName, dropbox, loader)
                }
            }
        },
        uploadfileAPi(file, eventName, dropbox, loader){
            this.$store.dispatch(eventName, file)
                .then(result => {
                    this.fileInfoList.push(result.data[0])
                    this.$emit("update:files", this.fileInfoList)
                    //로딩 이미지 삭제
                    this.loading_close(dropbox, loader)
                    this.dragUnOver()
                }).catch(error =>{
                    this.error.push(error)
                })
        },
        deleteFileAPi(id) {
            this.$emit("delete_file", id)
        },
        fileDrop(event){
           event.preventDefault()
            this.error = []  // 에러 초기화
            const files = event.dataTransfer.files
            this.file = files[0]
            const fileName = files[0].name
            const fileSize = files[0].size

            //File Check List
            this.formatCheck(fileName)
            this.sizeCheck(fileSize)
            this.filesUploadCountCheck(files)

            // 로딩바 생성
            const dropbox = document.getElementsByClassName("dropbox")[0] // dropbox Select
            const loader = document.createElement("div")
            this.loading(dropbox, loader)

            const reader = new FileReader();
            reader.onload = (e) => {
                let audio = new Audio();
            }

            if(this.error.length > 0){
                loader.classList.add('type4')
                setTimeout(function(){
                    dropbox.removeChild(loader)
                },4800)
                this.dragUnOver()
                return false
            }else{
                if (files[0]) {
                    reader.readAsDataURL(files[0])
                    this.uploadfileAPi(this.file, this.eventName, dropbox, loader)
                }
            }
        },
        fileChange(event){
            event.preventDefault()
            this.error = []  // 에러 초기화
            const files = event.target.files
            this.file = files[0]
            const fileName = files[0].name
            const fileSize = files[0].size

            //File Check List
            this.formatCheck(fileName)
            this.sizeCheck(fileSize)
            this.filesUploadCountCheck(files)

            // 로딩바 생성
            const dropbox = document.getElementsByClassName("dropbox")[0] // dropbox Select
            const loader = document.createElement("div")
            this.loading(dropbox, loader)

            const reader = new FileReader();
            reader.onload = (e) => {
                let audio = new Audio();
            }

            if(this.error.length > 0){
                loader.classList.add('type4')
                setTimeout(function(){
                    dropbox.removeChild(loader)
                },4800)
                this.dragUnOver()
                return false
            }else{
                if (files[0]) {
                    reader.readAsDataURL(files[0])
                    this.uploadfileAPi(this.file, this.eventName, dropbox, loader)
                }
            }
        },
        popupOpen(id, title){
            // popup Open
            let popup = document.getElementById(id + this.page_index)
            popup.classList.add('type2')
            this.guideMessage = title
            setTimeout(function(){
                popup.firstChild.classList.add('type2')
            }, 300)
        },
        popupClose(event){
            // popup close
          const parent = event.target.parentNode.parentNode.parentNode
          let popup = document.getElementById(parent.id)
          popup.firstChild.classList.remove('type2')
          setTimeout(function(){
              popup.classList.remove('type2')
          }, 300)
        },
        loading(parent, target){
            // 로딩바 생성
            target.setAttribute("id", this.previewStyle + "_loader"+ this.page_index)
            target.classList.add('loader')
            target.classList.add('type3')    
            parent.prepend(target)
        },
        loading_close(parent, target){
            // 로딩바 생성
            target.classList.add('type4')
            setTimeout(function(){
                parent.removeChild(target)
            },4800)
        }
    }
}
    
</script>

<style scoped>

.dropbox{
    overflow: visible;
    position: relative; 
    margin: 0 auto;
    background-color:#32325d;   
}

.dropbox > div{
    font-size: 0.85rem;
    word-break: keep-all;   
}

#imgfile{
    opacity: 0;
}

.input-file {
    position: absolute;
    opacity: 0;
    width: 96% !important;
    height: 96% !important;
    top:2%;
    left:2%;
    z-index: 1000;
    margin: 0 auto;
    cursor: pointer;
    color:transparent;
    border: 1px solid #888
}

.previewImage {
    position: absolute;
    width: 15rem;
    height: 15rem;
    top:0;
    left:0;
    z-index: 3;
    padding: 0.5rem;
}

.test{
    background-color:darkorange;
}

.test1{
    display:none;
}

.test:hover~.test1{
    display:block;
}

#tracksList{
    width: 100%;
}

.testCSS {
    opacity: 0;
    -webkit-transition: opacity 0.6s ease-in-out;
    -moz-transition: opacity 0.6s ease-in-out;
    transition: opacity 0.6s ease-in-out;
}


th, td{
    height: 30px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.listCount td:last-Child{
    cursor: pointer;
}

.scx_cbox_in{padding:30px 0 0;}
.scupe_cont_tb_w{margin:0 0 20px;}
.scupe_cont_tb_w .scupe_cont_td{padding-top:50px;padding-bottom:50px;}
.sctup_img{width:95px;height:95px;margin:0px auto;box-sizing:border-box;border:1px solid #cacaca;border-radius:100%;background:transparent url("../../assets/images/ico_upload.png") no-repeat 50% 50%;}
.list_sktb_w{border-top:1px solid #5d5d5d;}
.list_sktb_w.type2{border-top:1px solid #d6d6d6;}
.list_sktb{width:100%;table-layout:fixed;}
.list_sktb th,
.list_sktb td{border-bottom:1px solid #d6d6d6;text-align:center;}
.list_sktb th{font-size:16px;color:rgba(255,255,255,0.8);line-height:1;padding:20px 0 18px 0;}
.list_sktb td{color:rgba(255,255,255,0.8);padding:15px;font-size:0;line-height:0;}
.list_sktb td.has_img{font-size:0;line-height:0;}
.list_sktb td.has_srsprof_list{font-size:0;line-height:0;padding-top:10px;padding-bottom:8px;}
.list_sktb td.has_tracktit{padding-left:40px;padding-right:40px;}
.list_sktb td.has_tracktit.type2{padding-left:20px;padding-right:20px;}
.list_sktb td.nodata{text-align:center;padding:60px 20px;}
.list_sktb td.nodata .nodata_p{font-size:16px;}
.lsdata{font-size:16px;line-height:1;}
.btn_tracont{margin:0 7px;display:inline-block;width:25px;height:25px;background-repeat:no-repeat;background-position:50% 50%;}
.btn_tracont.ico02{background-image:url("../../assets/images/ico_dataclose.png");}
.hdtext{display:inline-block;width:0;height:0;overflow:hidden;line-height:0;color:transparent;}
.dac_lay{display:none;position:fixed;top:0;left:0;text-align:center;width:100%;height:100%;z-index:10000;background:url("../../assets/images/dim_075.png");}
.dac_lay.type2{display:block;position:fixed;padding-top:40vh;top:0;left:0;text-align:center;width:100%;height:100%;z-index:10000;background:url("../../assets/images/dim_075.png");}
.dac_lay.type3{display:block;position:fixed;padding-top:15vh;top:0;left:0;text-align:center;width:100%;height:100vh;z-index:10000;background:url("../../assets/images/dim_075.png");}

.loader {
  border: 3px solid #f3f3f3;
  border-radius: 50%;
  border-top: 3px solid #004998;
  width: 60px;
  height: 60px;
  margin:0 auto;
  -webkit-animation: spin 1.1s linear infinite; /* Safari */
  animation: spin 1.1s linear infinite;
}
.loader.type2{
  border-width: 2px;
  width: 40px;
  height: 40px;
}
/* 20200206 추가 */
.loader.type3{
	opacity: 1 !important;
	position: absolute;
	z-index: 5000;
	top: calc(50% - 30px);
	left: calc(50% - 30px);
  }

.loader.type4{
	opacity: 0 !important;
	transition: opacity 1.6s ease-out;
}

.btn_tracont.ico02{background-image:url("../../assets/images/ico_dataclose.png");}
</style>